import SwiperInstance from 'customs/swiper-instance'
import { getData } from 'helpers/dom'
import './carousel-swiper.css'

class CarouselSwiper extends HTMLElement {
  constructor() {
    super()

    this.type = this.getAttribute('data-type') || null
    this.config = this.getAttribute('data-config') ? JSON.parse(getData('config', this)) : null
    this.options = this.getAttribute('data-options') ? JSON.parse(getData('options', this)) : null

    if (this.config && this.options) {
      this.options = {
        ...this.options,
        on: {
          init: () => {
            this.type === 'component' && this.classList.add('swiper-initialized')
          }
        }
      }

      this.instance = new SwiperInstance(this, this.options, this.config)
    }
  }
}

if (!customElements.get('carousel-swiper')) {
  customElements.define('carousel-swiper', CarouselSwiper)
}
